export interface SlimeStateOptions {
  initialMassKg?: number;
  density?: number;
  maxEnergy?: number;
  initialEnergy?: number;
  level?: number;
}

export class SlimeState {
  public massKg: number;
  public readonly density: number;
  public readonly maxEnergy: number;
  public gelEnergy: number;
  public level: number;

  constructor(options: SlimeStateOptions = {}) {
    this.massKg = options.initialMassKg ?? 5.0;
    this.density = options.density ?? 1000.0;
    this.maxEnergy = options.maxEnergy ?? 100.0;
    this.gelEnergy = options.initialEnergy ?? this.maxEnergy;
    this.level = options.level ?? 1;
  }

  public get volumeM3(): number {
    return this.massKg / this.density;
  }

  public get baseRadius(): number {
    return Math.cbrt((3 * this.volumeM3) / (4 * Math.PI));
  }

  public addMass(deltaKg: number): void {
    if (deltaKg <= 0) return;
    this.massKg += deltaKg;
  }

  public consumeEnergy(amount: number): boolean {
    if (amount <= 0) return true;
    if (this.gelEnergy < amount) return false;
    this.gelEnergy -= amount;
    return true;
  }

  public restoreEnergy(amount: number): void {
    if (amount <= 0) return;
    this.gelEnergy = Math.min(this.maxEnergy, this.gelEnergy + amount);
  }
}
